<template>
  <layout-content>
    <filter-component />
    <table-component />
  </layout-content>
</template>

<script>
  import FilterComponent from '@autoinformer/components/campaigns-stats-detailed-table-filter';
  import TableComponent from '@autoinformer/components/campaigns-stats-detailed-table';

  export default {
    components: {
      FilterComponent,
      TableComponent
      
    }
  };
</script>
